'use client';

import { defineMessages, useIntl } from 'react-intl';
import { useIsHydrated } from '@packages/shared/src/hooks/useIsHydrated/useIsHydrated';
import { Button } from '@packages/shared/src/ui/Button/Button';

export type HamburgerButtonProps = {
  onClick: () => void;
};

const messages = defineMessages({
  primaryNavigationHamburgerIcon: {
    id: 'primary.navigation.hamburger.icon.label',
    defaultMessage: 'Navigation öffnen',
  },
});
export const HamburgerButton = ({ onClick }: HamburgerButtonProps) => {
  const { isHydrated } = useIsHydrated();
  const { formatMessage } = useIntl();

  return (
    <Button
      variant="icon-flat"
      size="large"
      className="text-color-accordion-toggle-icon m-0 flex lg:hidden"
      aria-label={formatMessage(messages.primaryNavigationHamburgerIcon)}
      onClick={onClick}
      disabled={!isHydrated}
    >
      <span className="icon-emp-burger-text size-4" />
    </Button>
  );
};
